/**
 * An enumeration of the types of fragment link that can be created.
 */
export enum FragmentLinkType {
  CLAUSE = 'CLAUSE',
}
